'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _skygearCore = require('skygear-core');

var _skygearCore2 = _interopRequireDefault(_skygearCore);

var _skygearForgotPassword = require('skygear-forgot-password');

var forgotPassword = _interopRequireWildcard(_skygearForgotPassword);

var _skygearSso = require('skygear-sso');

var sso = _interopRequireWildcard(_skygearSso);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Inject sub-package modules into container.
// Should keep in-sync with (project-root)/lib/index.js.
forgotPassword.injectToContainer(_skygearCore2.default);
sso.injectToContainer(_skygearCore2.default);

exports.default = _skygearCore2.default;
module.exports = exports['default'];